import { useCallback, useRef } from "react"

export const useBoundaryPost = <T,>(
  post: (params: T[] | undefined) => void,
  timeOut: number
) => {
  const boundaryPostTimer = useRef<NodeJS.Timeout | null>(null)
  const boundaryPost = useCallback(
    (boudaryData: T[]) => {
      if (boundaryPostTimer.current) clearTimeout(boundaryPostTimer.current)
      boundaryPostTimer.current = setTimeout(() => {
        post(boudaryData)
        boundaryPostTimer.current = null
      }, timeOut)
    },
    [post, timeOut, boundaryPostTimer]
  )
  return {
    boundaryPost
  }
}
